// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'
import IconInstagram from 'church-theme-library/components/svg/instagram.svg'
import { loop } from 'church-theme-library/utilities/objects'

// Redux:
import { getInstagramFeed } from 'church-theme-library/redux/actions/page'

class InstagramFeedApi extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch( getInstagramFeed() )
	}

	renderPost = ( key, item ) => {
		const { instagramURL } = this.props
		let className = '-item'

		return (
			<a href={ item.url } className={ className } target="_blank" rel="noopener" key={ key }>
				<div className="-inner">
					{ item.image.url &&
						<div className="-image-wrap">
							<div className="-image">
								<Image
									thumb={ item.image.thumb }
									thumbWebp={ item.image.thumb_webp }
									url={ item.image.url }
									srcset={ item.image.srcset }
									srcsetWebp={ item.image.srcset_webp }
									sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 700px` }
									alt={ item.image.alt }
									focalPoint={ item.image.focal_point }
									width={ item.image.width }
									height={ item.image.height }
									aspectRatio={ item.image.aspect_ratio }
								/>
							</div>
						</div>
					}

					<div className="-header">
						<div className="-source is-instagram">
							<IconInstagram />
						</div>

						<p className="-sub">{ item.date }</p>
					</div>

					<div className="-main">
						<p dangerouslySetInnerHTML={ { __html: item.content } } />
					</div>
				</div>
			</a>
		)
	}

	render() {
		const { contentId, sectionId, data, translate, instagramURL, instagramFeedById, userCanEditPage } = this.props

		if ( ! userCanEditPage &&
			( ! instagramFeedById || ! Object.keys( instagramFeedById ).length )
		) {
			return null
		}

		const postsMarkup = loop( instagramFeedById, this.renderPost )

		return (
			<div className="section-instagram-feed">
				{/*<div className="-inner">
					<div className="-text">
						<Editable
							element="h2"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="heading"
							content={ data.heading }
						/>

						<p className="with-button">
							<a href={ instagramURL } className="button" target="_blank" rel="noopener">{ translate( 'Follow us on Instagram' ) }</a>
						</p>
					</div>
				</div>*/}

				<div className="-feed">
					<div className="-inner">
						{ postsMarkup }
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let userCanEditPage = siteData.current_user_can_edit_pages

	if ( state.page.selected && state.page.selected.is_external ) {
		userCanEditPage = false
	}

	return {
		instagramURL: state.site.instagramURL,
		instagramFeedById: state.page.instagramFeedById,
		instagramFeedReceived: state.page.instagramFeedReceived,
		userCanEditPage
	}
}

export default localize(
	connect( mapStateToProps )( InstagramFeedApi )
)
